var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"userinfo"}},[_c('div',{staticStyle:{"height":"50px","background-color":"seagreen","text-align":"center","line-height":"50px","color":"aliceblue","font-weight":"bolder","font-size":"28px"}},[_vm._v("下载国度后台管理系统")]),_c('leftinfo'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }